import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword]               = useState("");
  const [confirmPassword, setConfirmPassword]  = useState("");
  const [showPassword, setShowPassword]        = useState(false);
  const [focusedField, setFocusedField]        = useState(null);
  const [loading, setLoading]                  = useState(false);
  const [error, setError]                      = useState("");
  const [success, setSuccess]                  = useState(false);

  const inputStyle = (field) => ({
    width: "100%",
    padding: "13px 18px 13px 42px",
    border: `2px solid ${focusedField === field ? "#C4441A" : "#E8DCC8"}`,
    borderRadius: 10,
    fontFamily: "'Space Grotesk', sans-serif",
    fontSize: 14,
    color: "#1C1008",
    background: "white",
    outline: "none",
    transition: "border-color .25s, box-shadow .25s",
    boxSizing: "border-box",
    boxShadow: focusedField === field ? "0 0 0 3px rgba(196,68,26,0.10)" : "none",
  });

  // ── Appel API backend ─────────────────────────────────────
  const handleSubmit = async () => {
    setError("");

    if (!password || !confirmPassword) {
      setError("Veuillez remplir les deux champs.");
      return;
    }
    if (password.length < 6) {
      setError("Le mot de passe doit contenir au moins 6 caractères.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`https://senutour.com/api/auth/reset-password/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
  <>
  <Navbar />
    <div style={{
      fontFamily: "'Space Grotesk', sans-serif",
      background: "#FAF5EC",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px 16px",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
        .btn-submit { background: #C4441A; transition: background .2s, transform .2s; }
        .btn-submit:hover:not(:disabled) { background: #A03614; transform: translateY(-1px); }
        .btn-submit:disabled { opacity: .6; cursor: not-allowed; }
        .link-auth { color: #C4441A; text-decoration: none; font-weight: 600; transition: color .2s; }
        .link-auth:hover { color: #A03614; }
        .eye-btn:hover { color: #C4441A !important; }
        @keyframes checkIn { from { opacity:0; transform: scale(0.5); } to { opacity:1; transform: scale(1); } }
        .check-anim { animation: checkIn .4s ease forwards; }
        @keyframes spin { to { transform: rotate(360deg); } }
        .spinner { animation: spin .8s linear infinite; display: inline-block; width: 18px; height: 18px; border: 2px solid rgba(255,255,255,.3); border-top-color: white; border-radius: 50%; }
        @media (max-width: 767px) {
          .auth-card { flex-direction: column !important; }
          .auth-left { width: 100% !important; padding: 32px 24px !important; }
          .auth-right { padding: 32px 24px !important; }
        }
      `}</style>

      <div className="auth-card" style={{
        width: "100%",
        maxWidth: 900,
        background: "white",
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 4px 40px rgba(28,16,8,0.10)",
        display: "flex",
        minHeight: 520,
      }}>

        {/* ── PANNEAU GAUCHE décoratif ── */}
        <div className="auth-left" style={{
          width: "42%",
          background: "#C4441A",
          padding: "48px 36px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          position: "relative",
          overflow: "hidden",
          flexShrink: 0,
        }}>
          <div style={{ position:"absolute", width:280, height:280, borderRadius:"50%", border:"45px solid rgba(255,255,255,0.07)", bottom:-90, left:-90 }} />
          <div style={{ position:"absolute", width:180, height:180, borderRadius:"50%", border:"35px solid rgba(255,255,255,0.06)", top:-50, right:-50 }} />

          {/* Logo */}
          <div style={{ position:"relative", zIndex:1, display:"flex", alignItems:"center", gap:8 }}>
            <div style={{ width:32, height:32, borderRadius:8, background:"rgba(255,255,255,0.2)", display:"flex", alignItems:"center", justifyContent:"center" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                <path d="M12 2C8 6 4 8 4 14a8 8 0 0 0 16 0c0-6-4-8-8-12z"/>
              </svg>
            </div>
            <span style={{ fontFamily:"'Fraunces',serif", fontSize:20, fontWeight:800, color:"white", letterSpacing:"-0.5px" }}>
              Senu<span style={{ color:"rgba(255,255,255,0.5)" }}>Tour</span>
            </span>
          </div>

          {/* Message */}
          <div style={{ position:"relative", zIndex:1 }}>
            <div style={{ width:56, height:56, borderRadius:"50%", background:"rgba(255,255,255,0.15)", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:20 }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8">
                <rect x="3" y="11" width="18" height="11" rx="2"/>
                <path d="M7 11V7a5 5 0 0110 0v4"/>
              </svg>
            </div>
            <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(20px,2.5vw,26px)", fontWeight:700, color:"white", lineHeight:1.3, marginBottom:12 }}>
              Nouveau mot de passe
            </h2>
            <p style={{ fontSize:13, color:"rgba(255,255,255,0.70)", lineHeight:1.7, margin:0 }}>
              Choisissez un mot de passe fort, différent de vos autres comptes, pour protéger votre accès SenuTour.
            </p>
          </div>

          <div style={{ position:"relative", zIndex:1 }} />
        </div>

        {/* ── PANNEAU DROIT (formulaire) ── */}
        <div className="auth-right" style={{
          flex: 1,
          background: "#FAF5EC",
          padding: "48px 40px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}>

          {!success ? (
            <>
              <h1 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(22px,3vw,28px)", fontWeight:800, color:"#1C1008", margin:"0 0 4px" }}>
                Réinitialiser le mot de passe
              </h1>
              <p style={{ fontSize:14, color:"#7A5A3A", margin:"0 0 28px" }}>
                Choisissez votre nouveau mot de passe
              </p>

              {/* Nouveau mot de passe */}
              <div style={{ marginBottom:16 }}>
                <label style={{ display:"block", fontSize:11, fontWeight:600, color:"#7A5A3A", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:5 }}>
                  Nouveau mot de passe
                </label>
                <div style={{ position:"relative" }}>
                  <span style={{ position:"absolute", left:13, top:"50%", transform:"translateY(-50%)", color:"#8B5E3C", display:"flex" }}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="11" width="18" height="11" rx="2"/>
                      <path d="M7 11V7a5 5 0 0110 0v4"/>
                    </svg>
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Au moins 6 caractères"
                    value={password} onChange={e => setPassword(e.target.value)}
                    onFocus={() => setFocusedField("password")}
                    onBlur={() => setFocusedField(null)}
                    style={{ ...inputStyle("password"), paddingRight: 44 }}
                  />
                  <button
                    type="button"
                    className="eye-btn"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ position:"absolute", right:13, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", color:"#8B5E3C", display:"flex", padding:0 }}
                    aria-label="Afficher le mot de passe"
                  >
                    {showPassword ? (
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                      </svg>
                    ) : (
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              {/* Confirmer mot de passe */}
              <div style={{ marginBottom:24 }}>
                <label style={{ display:"block", fontSize:11, fontWeight:600, color:"#7A5A3A", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:5 }}>
                  Confirmer le mot de passe
                </label>
                <div style={{ position:"relative" }}>
                  <span style={{ position:"absolute", left:13, top:"50%", transform:"translateY(-50%)", color:"#8B5E3C", display:"flex" }}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="11" width="18" height="11" rx="2"/>
                      <path d="M7 11V7a5 5 0 0110 0v4"/>
                    </svg>
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Retapez le mot de passe"
                    value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
                    onFocus={() => setFocusedField("confirm")}
                    onBlur={() => setFocusedField(null)}
                    style={inputStyle("confirm")}
                  />
                </div>
              </div>

              {/* Message d'erreur */}
              {error && (
                <div style={{ background:"rgba(196,68,26,.08)", border:"1.5px solid rgba(196,68,26,.2)", borderRadius:8, padding:"12px 16px", marginBottom:16 }}>
                  <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:13, color:"#C4441A", margin:0 }}>
                    ⚠️ {error}
                  </p>
                </div>
              )}

              {/* Bouton envoyer */}
              <button
                type="button"
                className="btn-submit"
                onClick={handleSubmit}
                disabled={loading}
                style={{
                  width:"100%", padding:"14px", color:"white",
                  border:"none", borderRadius:10, fontFamily:"'Space Grotesk',sans-serif",
                  fontSize:15, fontWeight:700, cursor:"pointer",
                  display:"flex", alignItems:"center", justifyContent:"center", gap:8,
                  boxShadow:"0 8px 20px rgba(196,68,26,0.30)",
                }}
              >
                {loading ? (
                  <span className="spinner" />
                ) : (
                  <>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="11" width="18" height="11" rx="2"/>
                      <path d="M7 11V7a5 5 0 0110 0v4"/>
                    </svg>
                    Réinitialiser le mot de passe
                  </>
                )}
              </button>

              <p style={{ textAlign:"center", fontSize:13, color:"#7A5A3A", marginTop:20 }}>
                <Link to="/connexion" className="link-auth">← Retour à la connexion</Link>
              </p>
            </>
          ) : (
            /* ── ÉTAT SUCCÈS ── */
            <div style={{ textAlign:"center" }}>
              <div className="check-anim" style={{
                width:72, height:72, borderRadius:"50%",
                background:"rgba(61,107,46,0.10)",
                display:"flex", alignItems:"center", justifyContent:"center",
                margin:"0 auto 24px",
              }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#3D6B2E" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>

              <h1 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(20px,3vw,26px)", fontWeight:800, color:"#1C1008", marginBottom:10 }}>
                Mot de passe réinitialisé !
              </h1>
              <p style={{ fontSize:14, color:"#7A5A3A", lineHeight:1.7, maxWidth:340, margin:"0 auto 32px" }}>
                Votre mot de passe a été changé avec succès. Vous pouvez maintenant vous connecter avec vos nouveaux identifiants.
              </p>

              <button
                type="button"
                className="btn-submit"
                onClick={() => navigate("/connexion")}
                style={{
                  width:"100%", padding:"14px", color:"white",
                  border:"none", borderRadius:10, fontFamily:"'Space Grotesk',sans-serif",
                  fontSize:15, fontWeight:700, cursor:"pointer",
                  display:"flex", alignItems:"center", justifyContent:"center", gap:8,
                  boxShadow:"0 8px 20px rgba(196,68,26,0.30)",
                }}
              >
                Aller à la connexion →
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
     <Footer />
    </>
  );
}